var map = {
	"./en.json": [
		"./resources/js/lang/en.json",
		124
	],
	"./fr.json": [
		"./resources/js/lang/fr.json",
		15
	],
	"./it.json": [
		"./resources/js/lang/it.json",
		478
	],
	"./nl.json": [
		"./resources/js/lang/nl.json",
		961
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./resources/js/lang lazy recursive ^\\.\\/.*\\.json$ referencedExports: ";
module.exports = webpackAsyncContext;